import fileDownload from 'js-file-download'
import { paginatedTransform, rawTransform } from 'src/services/skuit/utils'
import { Hierarchy, PaginatedResponse, Place } from '../../api/models'

import { API, CustomAxiosConfig } from './types'
import { ExportFilters } from 'src/services/skuit/types'

export interface ExportProps {
  fields: string[],
  exportFilters?: ExportFilters,
}

interface DetailProps {
  guid: string
  data?: any
  config?: CustomAxiosConfig
}

export class Places {
  api: API

  constructor(api: API) {
    this.api = api
  }

  create = async (data: any, config: CustomAxiosConfig = {}): Promise<Place> => {
    const response = await this.api.post('/logistics/places', data, config)
    return rawTransform(Place)(response.data)
  }

  patch = async (guid: string, data: any, config: CustomAxiosConfig = {}): Promise<Place> => {
    const response = await this.api.patch(`/logistics/places/${guid}`, data, config)
    return rawTransform(Place)(response.data)
  }

  list = async (config: CustomAxiosConfig = {}): Promise<PaginatedResponse<Place>> => {
    const response = await this.api.get('/logistics/places', config)
    return paginatedTransform(Place)(response.data)
  }

  retrieve = async (guid: string, config: CustomAxiosConfig = {}): Promise<Place> => {
    const response = await this.api.get(`/logistics/places/${guid}`, config)
    return rawTransform(Place)(response.data)
  }

  lost = async (props: DetailProps): Promise<null> => {
    const { guid, data = {}, config = {} } = props
    await this.api.post(`/logistics/places/${guid}/lost`, data, config)
    return null
  }

  found = async (props: DetailProps): Promise<null> => {
    const { guid, data = {}, config = {} } = props
    await this.api.post(`/logistics/places/${guid}/found`, data, config)
    return null
  }

  delete = async (guid: string, config: CustomAxiosConfig = {}): Promise<null> => {
    await this.api.delete(`/logistics/places/${guid}`, config)
    return null
  }

  bulkCreatePlaces = async (data: any, config: CustomAxiosConfig = {}): Promise<Place> => {
    const response = await this.api.post('/logistics/places/bulk', data, config)
    return rawTransform(Place)(response.data)
  }

  hierarchy = async (
    guid: string,
    config: CustomAxiosConfig = { params: {} }
  ): Promise<Hierarchy[]> => {
    config.params.places = guid
    const response = await this.api.get('/logistics/places/hierarchy', config)
    return rawTransform(Hierarchy)(response.data)
  }

  export = async ({ fields }: ExportProps ) => {
    const params = { fields: fields.join(',')}
    const response = await this.api.axiosInstance({
      url: '/logistics/places/export',
      params,
      responseType: 'blob',
    })
    fileDownload(response.data, 'places.csv')
  }
}
